import React from 'react';
import { motion } from 'framer-motion';
import { Shield } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-24 md:py-32 px-4 bg-bg-navy-deep" data-id="element-122">
      <div className="max-w-3xl mx-auto" data-id="element-123">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-bg-navy border-2 border-navy-trust rounded-2xl p-10 md:p-14 text-center shadow-navy-glow" data-id="element-124">
          <Shield className="text-gold-primary mx-auto mb-8" size={64} data-id="element-125" />
          <h2 className="text-text-primary font-display font-bold text-3xl md:text-4xl mb-6" data-id="element-126">
            GARANTÍA 7 DÍAS — SIN PREGUNTAS
          </h2>
          <p className="text-text-primary text-lg leading-relaxed mb-8 max-w-[500px] mx-auto" data-id="element-127">
            Abrís los módulos. Los aplicás esa semana.
            <br data-id="element-128" />
            Si en 7 días no es lo que esperabas:
            <br data-id="element-129" />
            devolución del 100% — sin formularios, sin drama.
          </p>
          <p className="text-text-secondary text-base" data-id="element-130">
            Tasa de devoluciones:{' '}
            <span className="text-text-gold font-bold" data-id="element-131">menos del 1%.</span>
          </p>
        </motion.div>
      </div>
    </section>;
}